import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {
  debounceTime,
  map,
  distinctUntilChanged,
  filter,
  tap,
} from 'rxjs/operators';
import { fromEvent } from 'rxjs';
@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.css'],
})
export class ClaimComponent implements OnInit {
  @ViewChild('inputSearch', { static: true }) inputSearch: ElementRef;
  @ViewChild('inputLocation', { static: true })
  inputLocation: ElementRef;

  showButton = false;
  loading = false;
  faithResults = [];
  loadMoreArr = [];
  totalItems;
  pageSize;
  closeResult: string;
  showFilters = false;
  arrList: any = [];
  pageNo;
  objArr = [];
  route = '/claim-list/claim-fellowship';
  modalOptions: NgbModalOptions;
  arr = [1, 2, 3, 4, 5];
  details;
  filterData;
  detailresult = true;
  location: any = '';
  search: any = '';
  searchInput: string = '';
  constructor(
    private authService: AuthservicesService,
    private router: Router,
    private modalService: NgbModal,
    private rt: ActivatedRoute
  ) {
    this.pageSize = 10;
  }

  ngOnInit(): void {

    this.searchFilter();

    this.rt.queryParams.subscribe((params) => {
      this.details = JSON.parse(JSON.stringify(params));
    });

    if (Object.keys(this.details).length == 0) {
      this.getClaimList(1);
    } else {
      this.detailresult = false;
      this.onFilter(1);
    }

  }


  searchFilter() {
    fromEvent(this.inputLocation.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          console.log()
          return event.target.value;
        }),
        tap(async () => {
          if (this.inputLocation.nativeElement.value == '') {
            this.inputLocation.nativeElement.value = '';
            this.location = '';
            this.getClaimList(1);
          }
        }),
        filter((res) => res.length > 2),
        debounceTime(1000),
      )
      .subscribe((location: string) => {
        this.loading = false;
        this.arrList = [];
        this.location = location;
        let obj = {
          search: this.searchInput,
          skip: 0,
          limit: this.pageSize,
          location: location,
        };

        this.authService.getCommunityClaimAffilation(obj).subscribe(
          (res: any) => {
            this.loading = true;
            this.arrList = res.items;
            this.totalItems = res.total;
            this.objArr = [];
            this.arrList.forEach((e) => {
              let address = `${e.address.streetAddress},${e.address.city},${e.address.stateName ? e.address.stateName : e.address.state
                },${e.address.country},${e.address.postalCode}`;
              this.objArr.push({
                id: e._id ? e._id : '',
                name: e.name ? e.name : '',
                description: e.address.location ? address : '',
                photo: e.photo ? this.renderImage(e.photo) : '',
                claimType: 'claim',
              });
            });
            this.pageNo = 1;
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
      });

    fromEvent(this.inputSearch.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        tap(async () => {
          if (this.inputSearch.nativeElement.value == '') {
            this.inputSearch.nativeElement.value = ''
            this.searchInput = '';
            this.getClaimList(1);
          }
        }),
        filter((res) => res.length > 2),
        debounceTime(1000),
      )
      .subscribe((text: string) => {
        this.search = text;
        this.loading = false;
        this.arrList = [];
        this.searchInput = text;
        let obj = {
          search: text,
          skip: 0,
          limit: this.pageSize,
          location: this.location,
        };


        this.authService.getCommunityClaimAffilation(obj).subscribe(
          (res: any) => {
            this.loading = true;
            this.arrList = res.items;
            this.totalItems = res.total;
            this.objArr = [];
            this.arrList.forEach((e) => {
              let address = `${e.address.streetAddress},${e.address.city},${e.address.stateName ? e.address.stateName : e.address.state
                },${e.address.country},  ${e.address.postalCode}`;
              this.objArr.push({
                id: e._id ? e._id : '',
                name: e.name ? e.name : '',
                description: e.address.location ? address : '',
                photo: e.photo ? this.renderImage(e.photo) : '',
                claimType: 'claim',
              });
            });
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
      });
  }

  getClaimList(event) {
    this.loading = false;
    this.arrList = [];
    this.objArr = [];
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);

    let obj = {
      search: this.inputSearch.nativeElement.value,
      skip: skip,
      limit: this.pageSize,
      location: this.inputLocation.nativeElement.value
    };

    this.authService.getCommunityClaimAffilation(obj).subscribe(
      (res: any) => {
        this.loading = true;
        this.arrList = res.items;
        this.totalItems = res.total;
        this.arrList.forEach((e) => {
          let address = `${e.address.streetAddress},${e.address.city},${e.address.stateName ? e.address.stateName : e.address.state
            },${e.address.country}, ${e.address.postalCode}`;

          this.objArr.push({
            id: e._id ? e._id : '',
            name: e.name ? e.name : '',
            description: e.address.location ? address : '',
            photo: e.photo ? this.renderImage(e.photo) : '',
            claimType: 'claim',
          });
        });
      },
      (error) => {
        this.loading = false;
        console.log(error);
      }
    );
  }

  onFilter(event: any) {
    this.loading = false;
    this.objArr = [];
    this.arrList = [];
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.details['skip'] = skip;
    this.details['limit'] = this.pageSize;
    this.authService.getCommunityClaimAffilation(this.details).subscribe(
      (res: any) => {
        this.loading = true;
        this.filterData = res.items;
        this.totalItems = res.total;

        this.filterData.forEach((e) => {
          let address = `${e.address.streetAddress},${e.address.city},${e.address.stateName ? e.address.stateName : e.address.state
            },${e.address.country}, ${e.address.postalCode}`;

          this.objArr.push({
            id: e._id ? e._id : '',
            name: e.name ? e.name : '',
            description: e.address.location ? address : '',
            photo: e.photo ? this.renderImage(e.photo) : '',
            claimType: 'claim',
          });
        });

        this.modalService.dismissAll();
      },

      (error) => {
        this.authService.successMessage(error.error.message, 'error');
        console.log(error);
      }
    );
  }
  setPagination(event: any) {
    console.log('event', event);
    if (this.arrList.length != '') {
      this.getClaimList(event);
    } else if (this.filterData.length != '[]') {
      this.onFilter(event);
    }
  }

  removeFilters() {
    if (this.inputSearch.nativeElement.value || this.inputLocation.nativeElement.value) {
      this.inputSearch.nativeElement.value = '';
      this.inputLocation.nativeElement.value = '';
      this.getClaimList(1);
    }
    else {
      var snapshot = this.rt.snapshot;
      const params = { ...snapshot.queryParams };
      for (var props in params) delete params[props];
      this.router.navigate([], { queryParams: params });
      this.detailresult = true;
      this.getClaimList(1);
    }
  }

  renderImage(data) {
    return this.authService.spilturl(data);
  }
  openSignUpPage(){
    this.router.navigate(['/sign-up']);
  }
}
